import {
  UPDATE_CANDIDATE_EXPERIENCE_REQUEST,
  UPDATE_CANDIDATE_EXPERIENCE_SUCCESS,
  UPDATE_CANDIDATE_EXPERIENCE_ERROR,
  RESET_CANDIDATE_EXPERIENCE_MESSAGE,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
};

const updateCandidateExperienceReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CANDIDATE_EXPERIENCE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_CANDIDATE_EXPERIENCE_SUCCESS:
      console.log("us", action.payload);
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case UPDATE_CANDIDATE_EXPERIENCE_ERROR:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case RESET_CANDIDATE_EXPERIENCE_MESSAGE:
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default updateCandidateExperienceReducer;
